import * as actionTypes from "./actionTypes";
import DeviceService from "../../api/deviceV2Service";
import {store} from "../store";
import {getImeiListFromDevices} from "../../shared/utils/utils";
import moment from "moment";
import fileSaver from 'file-saver'
import { getUrlWithFilters} from "../../shared/utils/axiosUtils";
import {toastError} from "../../shared/components/toast/Toast";

const description = (description, model) => {
    if (description === '' && model === '') return null;
    return description || model;
}

export const getVenditaTable = (page, size, sorting, integrationId, filter) => {
    const sortParts = sorting.split(',')
    const sortBy = sortParts[0] === "null" ? null : sortParts[0]
    const imei = filter.imei.value === "" ? null : filter.imei.value
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value
    const tags = filter.tags.value === "" ? null : filter.tags.value.map(f => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map(f => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined

    return (dispatch) => {
        dispatch({type: actionTypes.GET_VENDITA_TABLE, value: true, key: "loading"})
        DeviceService.fetchVendita(page, size, sortBy, sortParts[1].toUpperCase(),
            integrationId,
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_VENDITA_TABLE,
                    value: res.data,
                    key: "data"
                })
                getDevicesDataSuccess(dispatch, res.data, "venditaTableData")
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.GET_VENDITA_TABLE,
                    value: {data:[], totalElements:0},
                    key: "data"
                })
                console.error(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_VENDITA_TABLE, value: false, key: "loading"})
            })
    }
}

export const getNoleggioTable = (page, size, sorting, integrationId, filter) => {
    const sortParts = sorting.split(',')
    const sortBy = sortParts[0] === "null" ? null : sortParts[0]
    const imei = filter.imei.value === "" ? null : filter.imei.value
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value
    const tags = filter.tags.value === "" ? null : filter.tags.value.map(f => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map(f => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined

    return (dispatch) => {
        dispatch({type: actionTypes.GET_NOLEGGIO_TABLE, value: true, key: "loading"})
        DeviceService.fetchNoleggio(page, size, sortBy, sortParts[1].toUpperCase(),
            integrationId,
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_NOLEGGIO_TABLE,
                    value: res.data,
                    key: "data"
                })
                getDevicesDataSuccess(dispatch, res.data, "noleggioTableData")
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.GET_NOLEGGIO_TABLE,
                    value: {data:[], totalElements:0},
                    key: "data"
                })
                console.error(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_NOLEGGIO_TABLE, value: false, key: "loading"})
            })
    }
}

export const getNoleggioInScadenzaTable = (page, size, sorting, integrationId, filter) => {
    const sortParts = sorting.split(",");
    const sortBy = sortParts[0] === "null" ? null : sortParts[0];
    const imei = filter.imei.value === "" ? null : filter.imei.value;
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value;
    const tags = filter.tags.value === "" ? null : filter.tags.value.map((f) => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map((f) => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value;
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value;
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value;
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value;
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined;
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value;
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined;
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined;

    return (dispatch) => {
        dispatch({type: actionTypes.GET_NOLEGGIO_IN_SCADENZA_TABLE,value: true,key: "loading"});
        DeviceService.fetchNoleggioInScadenza(page, size, sortBy, sortParts[1].toUpperCase(),
            integrationId,
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore
        )
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_NOLEGGIO_IN_SCADENZA_TABLE,
                    value: res.data,
                    key: "data",
                });
                getDevicesDataSuccess(
                    dispatch,
                    res.data,
                    "noleggioInScadenzaTableData"
                );
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.GET_NOLEGGIO_IN_SCADENZA_TABLE,
                    value: { data: [], totalElements: 0 },
                    key: "data",
                });
                console.error(err);
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_NOLEGGIO_IN_SCADENZA_TABLE,
                    value: false,
                    key: "loading",
                });
            });
    };
};

export const getRestituzioniTable = (page, size, sorting, integrationId, filter) => {
    const sortParts = sorting.split(',')
    const sortBy = sortParts[0] === "null" ? null : sortParts[0]
    const imei = filter.imei.value === "" ? null : filter.imei.value
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value
    const tags = filter.tags.value === "" ? null : filter.tags.value.map(f => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map(f => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined
    const statoRestituzione = filter.statoRestituzione.value === "" ? null : filter.statoRestituzione.value

    return (dispatch) => {
        dispatch({type: actionTypes.GET_RESTITUZIONI_TABLE, value: true, key: "loading"})
        DeviceService.fetchRestituzioni(page, size, sortBy, sortParts[1].toUpperCase(),
            integrationId,
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore,
            statoRestituzione)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_RESTITUZIONI_TABLE,
                    value: res.data,
                    key: "data"
                })
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.GET_RESTITUZIONI_TABLE,
                    value: {data:[], totalElements:0},
                    key: "data"
                })
                console.error(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_RESTITUZIONI_TABLE, value: false, key: "loading"})
            })
    }
}

export const getDeviceDetails = (imei, integrationId) => {
    return (dispatch) => {
        dispatch({type: actionTypes.GET_DEVICE_DETAILS, value: true, key: "loading"})
        DeviceService.fetchDeviceDetails(imei, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_DEVICE_DETAILS,
                    value: res.data,
                    key: "data"
                })
            })
            .catch((err) => {
                console.error(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_DEVICE_DETAILS, value: false, key: "loading"})
            })
    }
}

export const clearDeviceDetails = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_DEVICE_DETAILS,
            value: {
                tagsForDeviceList: [],
                firstRenderTags: [],
            },
            key: "data"
        })
    }
}

const getDevicesDataSuccess = (dispatch, data, type) => {
    dispatch({type: actionTypes.SET_WRENCH_LOADING_DEVICES_V2, value: true});
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;

    const wrenchDetailsDto = {
        imeiList: getImeiListFromDevices(data.data),
        integrationId: integrationId,
        changeInSelf: changeInSelf
    }
    DeviceService.fetchWrenchDetails(wrenchDetailsDto).then((res) => {
        dispatch({type: actionTypes.SET_WRENCH_DETAILS_DEVICE_V2, wrenchDetails: res.data, deviceType: type})
    }).catch((e) => {
        console.log(e);
    }).then(() => {
        dispatch({type: actionTypes.SET_WRENCH_LOADING_DEVICES_V2, value: false});
    })
}

export const getDeviceTabCount = (tabName, filter) => {
    const imei = filter.imei.value === "" ? null : filter.imei.value
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value
    const tags = filter.tags.value === "" ? null : filter.tags.value.map(f => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map(f => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined

    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        dispatch({type: actionTypes.SET_DEVICE_TAB_COUNT_LOADING, payload: true, key: tabName})
        DeviceService.fetchDeviceTabsCount(integrationId, tabName,
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore)
            .then(res => {
                dispatch({
                    type: actionTypes.SET_DEVICE_TAB_COUNT,
                    payload: res.data,
                    key: tabName,
                })
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_DEVICE_TAB_COUNT_LOADING, payload: false, key: tabName})
            })
    }
}

export const getRestituzioneDetails = (nOrdineReso) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        dispatch({type: actionTypes.GET_RESTITUZIONI_DETAILS_AND_LOADING, value: true, key: 'loading'})
        DeviceService.fetchRestituzioniDetails(integrationId, nOrdineReso)
            .then(res => {
                dispatch({
                    type: actionTypes.GET_RESTITUZIONI_DETAILS_AND_LOADING,
                    value: res.data,
                    key: 'data',
                })
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_RESTITUZIONI_DETAILS_AND_LOADING, value: false, key: 'loading'})
            })
    }
}

export const getRestituzioniDetailsTable = (nOrdineReso, page, size, sorting, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const sortParts = sorting.split(',')
    const sortBy = sortParts[0] === "null" ? null : sortParts[0]
    const imei = filter.imei.value === "" ? null : filter.imei.value
    const prodotto = filter.prodotto.value === "" ? null : filter.prodotto.value
    const tags = filter.tags.value === "" ? null : filter.tags.value.map(f => f.label).join(",");
    const collaborators = filter.collaborators.value === "" ? null : filter.collaborators.value.map(f => f.id).join(",");
    const descrizione = description(filter.descrizione.value, filter.model.value);
    const contratto = filter.contratto.value === "" ? null : filter.contratto.value
    const idSpedizione = filter.idSpedizione.value === "" ? null : filter.idSpedizione.value
    const tipologiaDiVendita = filter.tipologiaDiVendita.value === "" ? null : filter.tipologiaDiVendita.value
    const assistenza = filter.assistenza.value === "" ? null : filter.assistenza.value
    const dataTermineAssistenza = filter.dataTermineAssistenza.from ? moment(filter.dataTermineAssistenza.from).format("YYYY-MM-DD") : undefined
    const interventiInAssistenza = filter.interventiInAssistenza.value === "" ? null : filter.interventiInAssistenza.value
    const dataConsegnaAfter = filter.dataConsegna.from ? moment(filter.dataConsegna.from).format("YYYY-MM-DD") : undefined
    const dataConsegnaBefore = filter.dataConsegna.to ? moment(filter.dataConsegna.to).format("YYYY-MM-DD") : undefined

    return (dispatch) => {
        dispatch({type: actionTypes.GET_RESTITUZIONI_DETAILS_TABLE, value: true, key: "loading"})
        DeviceService.fetchRestituzioniDetailsTable(integrationId, nOrdineReso, page, size, sortBy, sortParts[1].toUpperCase(),
            imei,
            prodotto,
            tags,
            collaborators,
            descrizione,
            contratto,
            idSpedizione,
            tipologiaDiVendita,
            assistenza,
            dataTermineAssistenza,
            interventiInAssistenza,
            dataConsegnaAfter,
            dataConsegnaBefore)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_RESTITUZIONI_DETAILS_TABLE,
                    value: res.data,
                    key: "data"
                })
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.GET_RESTITUZIONI_DETAILS_TABLE,
                    value: {data: [], totalElements: 0},
                    key: "data"
                })
                console.error(err)
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_RESTITUZIONI_DETAILS_TABLE, value: false, key: "loading"})
            })
    }
}

export const downloadDevicesVenditaCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadVenditaCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesNoleggioCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadNoleggioCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesNoleggioInScadenzaCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadNoleggioInScadenzaCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesNoleggioScadutoCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadNoleggioScadutoCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesRestituzioniCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadRestituzioniCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesRestituzioniDetailsCsv = (nOrdineReso, selected) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadRestituzioniDetailsCsv(integrationId, nOrdineReso, selected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const downloadDevicesCsv = (selectedDevices, areAllSelected) => {
    const state = store.getState().deviceReducer;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(state.device.sorting, 0, 25, integrationId, state.filter);
    return (dispatch) => {
        dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: true})
        DeviceService.downloadVenditaCsv(selectedDevices, url, areAllSelected).then((res) => {
            fileSaver.saveAs(res.data, `devices_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_DEVICE_V2_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}